<template>
<div class="landing mt-5">

  <!-- Sucess Message Display -->
  <MessageBar v-show="message.show" color="success">
    {{ this.message.message }}
    <v-btn dark flat @click="message.show = false">
      <v-icon>cancel</v-icon>
    </v-btn>
  </MessageBar>

  <!-- Error Message Display -->
  <MessageBar @closeMessage="error.show=false" v-show="error.show">
    {{ this.error.message }}
    <v-btn dark flat @click="error.show=false">
      <v-icon>cancel</v-icon>
    </v-btn>
  </MessageBar>

  <!-- Password Reset Modal -->
  <v-dialog v-model="modalActive" width="500">
    <v-card>
      <v-card-title class="headline green darken-3" primary-title>
        <a href="#" @click="modalActive = false" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5 white--text">Enter your email to reset password</div>
      </v-card-title>

      <v-card-text>
        <v-text-field prepend-icon="mail" color="green lighten-2" @focus="$event.target.select()" value="email" placeholder="Email address" v-model="resetEmail" type="text" class="form-input" autofocus></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green lighten-2" flat @click="sendResetEmail">
          Reset Password
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container fluid>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex xs12 md6 order-md1 order-xs2 px-3>
        <v-img src="/static/img/devicePreview.png" lazy-src="/static/img/devicePreview.png" />
        <p class="headline">QikByte - Calendar, Chat, Attachments, and More!</p>
        <p class="green--text text--lighten-1">We make it easy to share and collaborate from start to finish.</p>
      </v-flex>
      <v-flex xs12 md4 offset-md-2 order-xs1 class="mb-4">
        <v-tabs v-model="model" centered slider-color="transparent">
          <v-tab color="green" href="#tab-1">
            Sign Up
          </v-tab>
          <v-tab color="green" href="#tab-2">
            Sign In
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="model">
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text>
                <form @submit.prevent data-vv-scope="signup">
                  <span id="name-container">
                    <v-text-field
                      color="green lighten-2"
                      v-validate.disable="'required|alpha'"
                      v-model.trim="firstName"
                      class="form-input"
                      type="text"
                      name="firstname"
                      placeholder="First Name"
                    ></v-text-field>
                    <v-text-field
                      v-validate.disable="'required|alpha'"
                      color="green lighten-2"
                      v-model.trim="lastName"
                      class="form-input"
                      type="text"
                      name="lastname"
                      placeholder="Last Name"
                    ></v-text-field>
                  </span>
                  <v-text-field color="green lighten-2" v-validate.disable="'required|email'" v-model="newEmail" type="email" class="form-input" name="email" placeholder="Email Address"></v-text-field>
                  <v-text-field color="green lighten-2" v-validate.disable="'required|min:6'" v-model="newPassword" class="form-input" type="password" name="password" placeholder="Password"></v-text-field>
                  <v-checkbox v-model="terms" type="checkbox" color="green" name="terms" v-validate.disable="'required'" class="mb-4" prepend-icon="pageview" @click:prepend="() => (showDialog = !showDialog)" label="Agree to terms" hint="Click icon to review terms of service"
                    persistent-hint></v-checkbox>
                  <Terms :visible="showDialog" @close="showDialog = false" />
                  <v-btn @click="createAccount" class="my-2 mx-1">Sign Up</v-btn>
                </form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-card-text>
                <!-- Login Form -->
                <!-- <section class="navbar-section"> -->
                <form @submit.prevent method="" data-vv-scope="login">
                  <v-text-field color="green lighten-2" v-validate.disable="'required|email'" name="email" ref="email" v-model="email" placeholder="Email" type="email" class="form-input form-inline mx-1"></v-text-field>
                  <v-text-field color="green lighten-2" v-validate.disable="'required|min:6'" name="password" v-model="password" placeholder="Password" type="password" class="form-input form-inline mx-1" @keydown.enter="logIn"></v-text-field>
                  <v-btn @click="logIn" class="my-2">Sign In</v-btn>
                </form>
                <!-- </section> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small flat color="grey lighten-1" style="cursor: pointer; text-transform: capitalize" @click="modalActive = true">Forgot Password?</v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>

</div>
</template>

<script>
import firebase, {
  db,
  FirebaseConsts
} from "@/firebaseConfig";
import MessageBar from "@/components/Shared/MessageBar";
import Terms from "@/components/Privacy/Terms";
export default {
  name: "landing",
  components: {
    MessageBar,
    Terms
  },
  data: function() {
    return {
      showDialog: false,
      model: 'tab-1',
      // user: null,
      // Login Variables
      email: "",
      password: "",
      // New Account Variables
      firstName: "",
      lastName: "",
      newEmail: "",
      newPassword: "",
      terms: '',
      // Reset Email Form Variable
      resetEmail: "",
      // Error Message Popup
      error: {
        show: false,
        message: "",
        // Should message contain password reset prompt?
        passPrompt: false
      },
      // Generic Message Popup
      message: {
        show: false,
        message: ""
      },
      modalActive: false,
      dictionary: {
        custom: {
          firstname: {
            required: () => 'First name is required',
            // custom messages
          },
          lastname: {
            required: () => 'Last name is required',
            // custom messages
          },
          email: {
            required: () => 'Please enter a valid email address',
            // custom messages
          },
          password: {
            required: () => 'Password can not be empty',
            // custom messages
          },
          terms: {
            required: () => 'Must agree to terms to proceed',
            // custom messages
          }
        }
      },
    };
  },
  computed: {
    // Only runs on page reload. Used to center logo on mobile
    centerTitle: function() {
      if (window.innerWidth <= 600) {
        return {
          width: "100%"
        };
      }
      return {};
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    logIn() {
      // Attempt to log in
      this.$validator.validateAll("login").then(result => {
        if (!result) {
          // there is a validation error, display them in order
          if (this.errors.has("login.email")) {
            this.error.message = this.errors.first("login.email");
          } else if (this.errors.first("login.password")) {
            this.error.message = this.errors.first("login.password");
          }
          this.error.show = true;
          this.error.passPrompt = true;
        } else {
          firebase
            .auth()
            .setPersistence(FirebaseConsts.auth.Auth.Persistence.LOCAL)
            .then(() => {
              firebase
                .auth()
                .signInWithEmailAndPassword(this.email, this.password)
                .then(user => {
                  this.$store.commit("setUID", user.user.uid);
                  this.$router.replace("dashboard");
                })
                .catch(error => {
                  this.error.show = true;
                  this.error.passPrompt = true;
                  this.error.message = error.message;
                });
            })
            .catch(error => {
              this.error.show = true;
              this.error.passPrompt = true;
              this.error.message = error.message;
            });
        }
      });
    },
    createAccount() {
      // Attempt to create an account
      this.$validator.validateAll("signup").then(result => {
        if (!result) {
          if (this.errors.first("signup.firstname")) {
            this.error.message = this.errors.first("signup.firstname");
          } else if (this.errors.first("signup.lastname")) {
            this.error.message = this.errors.first("signup.lastname");
          } else if (this.errors.first("signup.email")) {
            this.error.message = this.errors.first("signup.email");
          } else if (this.errors.first("signup.password")) {
            this.error.message = this.errors.first("signup.password");
          } else if (this.errors.first("signup.terms")) {
            this.error.message = this.errors.first("signup.terms");
          }
          this.error.show = true;
          this.error.passPrompt = false;
        } else {
          firebase
            .auth()
            .setPersistence(FirebaseConsts.auth.Auth.Persistence.LOCAL)
            .then(() => {
              var fullName = this.firstName + " " + this.lastName;
              firebase
                .auth()
                .createUserWithEmailAndPassword(this.newEmail, this.newPassword)
                .then(authUser => {
                  authUser.user
                    .updateProfile({
                      displayName: fullName //pass displayName from form
                    })
                    .then(() => {
                      //redirect to the dashboard
                      this.newUserToStore(authUser.user);
                      this.$router.replace("dashboard");
                    })
                    .catch(error => {
                      this.error.show = true;
                      this.error.passPrompt = false;
                      this.error.message = error.message;
                    });
                  // }
                })
                .catch(error => {
                  this.error.show = true;
                  this.error.passPrompt = false;
                  this.error.message = error.message;
                });
            });
        }
      });
    },
    googleSignIn() {
      let provider = new FirebaseConsts.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        // .signInWithRedirect(provider)
        .then(result => {
          if (result.user) {
            this.newUserToStore(result.user);
            this.$router.replace("dashboard");
          }
        })
        .catch(error => {
          this.error.show = true;
          this.error.passPrompt = false;
          this.error.message = error.message;
        });
    },
    sendResetEmail() {
      this.error.show = false;
      this.modalActive = false;
      firebase
        .auth()
        .sendPasswordResetEmail(this.resetEmail)
        .then(() => {
          this.message.show = true;
          this.message.message =
            "Email with password reset instructions has been sent to  " +
            this.resetEmail;
        })
        .catch(error => {
          this.error.show = true;
          this.error.passPrompt = false;
          this.error.message = error.message;
        });
    },
    newUserToStore(userAccount) {
      db.collection("users")
        .doc(userAccount.uid)
        .set({
          uid: userAccount.uid,
          displayName: userAccount.displayName,
          photoURL: userAccount.photoURL,
          description: null,
          projectSets: []
        });
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  }
};
</script>

<style lang="scss" scoped>
h1 {
    font-size: 4em;
}
p {
    font-size: 1.5em;
}

// Images should be centered in their column
.undraw-svg {
    width: 14em;
    margin: auto;
}

// Enlarges images on hober
.undraw-svg:hover {
    transform: scale(1.25);
    top: 5px;
    z-index: 999;
}

// Aligns all content vertically on the screen
.bodyContainer {
    min-height: 92vh;
    display: flex;
    flex: row;
    justify-content: center;
    align-content: center;
    align-items: center;
}

// Signup form input box widths
.column input {
    width: 25em;
    margin: auto;
}

// Right signup information should be centered vertically and horizontally
#right-container {
    display: flex;
    flex-direction: col;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

// Set login input form widths
.navbar-section input {
    width: 35%;
}

.navbar-brand {
    font-family: "Pacifico", cursive;
    font-size: 2em;
    color: white;
}

#logo {
    font-family: "Pacifico", cursive;
    font-size: 6vw;
}
form {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Landing.vue